import { Alarm, UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import {
  BasicPanel,
  DescriptionList,
  DescriptionListItem,
} from '@hakimo-ui/hakimo/ui-elements';
import { buildDLItems } from './util';

interface Props {
  alarm?: Alarm;
  event?: UnifiedAlarm;
}

function AlarmSummary({ alarm, event }: Props) {
  const data: Alarm | UnifiedAlarm | undefined = alarm ?? event;
  const items: DescriptionListItem[] = data ? buildDLItems(data) : [];

  return (
    <BasicPanel title="Overview">
      <div className="min-h-[20rem] px-6 pb-4">
        <DescriptionList items={items} align="vertical" />
      </div>
    </BasicPanel>
  );
}

export default AlarmSummary;
